import TopBar from './components/TopBar';
import Header from './components/Header';
import CategoryGrid from './components/CategoryGrid';
import PromoSlider from './components/PromoSlider';
import CollagenProducts from './components/CollagenProducts';
import MarketplaceSection from './components/MarketplaceSection';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import AgeGroupSection from './components/AgeGroupSection';
import FamilyHealthSection from './components/FamilyHealthSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      <PromoSlider />
      <HeroSection />
      <CategoryGrid />
      <TrustBadges />
      <AgeGroupSection />
      <CollagenProducts />
      <FamilyHealthSection />
      <TestimonialsSection />
      <MarketplaceSection />
      <Newsletter />
      <Footer />
    </div>
  );
}